export default "__VITE_ASSET__1b3bb9ef__"